import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    role: 'Gerente de Proyectos',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80',
    quote: 'Por fin cierro algo real cada día. Antes terminaba exhausta sin saber qué había logrado. Ahora tengo menos ruido mental porque veo el progreso.'
  }, {
    name: 'Carlos Ruiz',
    role: 'Emprendedor Tech',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80',
    quote: 'El protocolo de retorno cambió mi vida. Me interrumpen igual que antes, pero ya no pierdo el hilo. Vuelvo al bloque y sigo.'
  }, {
    name: 'Ana Martínez',
    role: 'Directora de Marketing',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80',
    quote: 'Implementé el sistema en 2 días. La sensación de cerrar una tarea importante cada día es adictiva. Mi equipo también lo está usando.'
  }];
  return <section className="py-24 bg-dark-800" data-id="element-519">
      <div className="max-w-7xl mx-auto px-4" data-id="element-520">
        <div className="text-center mb-16" data-id="element-521">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-522">
            Historias de{' '}
            <span className="text-gold-500 font-serif italic" data-id="element-523">Cierre</span>
          </h2>
          <p className="text-gray-400" data-id="element-524">
            Profesionales que recuperaron control con el Método CIERRE 90'
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-525">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-dark-900 p-8 rounded-2xl border border-white/5 relative" data-id="element-526">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gold-500/20" data-id="element-527" />

              <div className="flex gap-1 mb-6" data-id="element-528">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-529" />)}
              </div>

              <p className="text-gray-300 mb-8 leading-relaxed min-h-[120px]" data-id="element-530">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-531">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border border-gold-500/50" data-id="element-532" />
                <div data-id="element-533">
                  <h4 className="text-white font-bold" data-id="element-534">{testimonial.name}</h4>
                  <p className="text-gold-500 text-sm" data-id="element-535">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}